import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import classNames from 'classnames';
import styles from './desktop_type_item.module.scss';
import { useRestrictedModal } from '../../../components/modal/useRestrictedModal';
import { Hyperlink } from '../../../components/Hyperlink';
import { buildUrlWithParameters } from '../../../utils/url-utils/urlUtils';
import { useUser } from '../../../user/useUser';
import { StateType } from '../../../state/reducers';

type Props = {
  onTypeChanged: (
    event: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
  ) => void;
  type: keyof StateType['results']['counts'];
};

export const DesktopTypeItem: FC<Props> = ({
  onTypeChanged,
  type,
  children,
}) => {
  const { accessPremium } = useUser();
  const { openRestrictedModal } = useRestrictedModal();

  const { url, selected } = useSelector(
    ({ queryParams, results }: StateType) => ({
      url: `/search?q=${results.query}&type=${type}`,
      selected: queryParams.type === type,
    }),
  );

  const linkProps = accessPremium
    ? {
        href: buildUrlWithParameters(url, {
          source: 'search-types',
        }),
        onClick: onTypeChanged,
      }
    : {
        onClick: () => openRestrictedModal({ source: 'search-types' }),
      };
  return (
    <Hyperlink
      data-test-id="search-type"
      {...linkProps}
      className={classNames(styles.item, selected && styles.selectedItem)}
    >
      {children}
    </Hyperlink>
  );
};
